import React from "react";
import { Logout } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, List, Drawer, Divider, IconButton } from "@mui/material";

import { api } from "api";
import { THEME } from "styles";
import { NAVIGATION, ROUTES } from "constants/routes";

import { LinkListItem } from "./link-list-item";

export const TopBarNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

  React.useEffect(() => {
    setIsDrawerOpen(false);
  }, [location.pathname]);

  React.useEffect(() => {
    if (location.pathname === "/") {
      navigate(ROUTES.Routes.Build);
    }
  }, [location, navigate]);

  return (
    <>
      <Box
        sx={{
          height: "70px",
          padding: "0 12px",
          display: "flex",
          flexShrink: 0,
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: `1px solid ${THEME.border}`,
        }}
      >
        <IconButton onClick={() => setIsDrawerOpen(!isDrawerOpen)}>
          <MenuIcon color="info" />
        </IconButton>

        <IconButton onClick={() => void api.admin.logout()}>
          <Logout color="error" />
        </IconButton>
      </Box>

      <Drawer
        anchor="left"
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      >
        <Box sx={{ width: "300px" }}>
          <List>
            {NAVIGATION.map((navigations, index) => {
              return (
                <React.Fragment key={`navigation-group-${index}`}>
                  {navigations.map((item) => (
                    <LinkListItem
                      to={item.to}
                      label={item.label}
                      secondary={item.secondary}
                      key={`nav-item-${item.label}`}
                    />
                  ))}
                  <Divider />
                </React.Fragment>
              );
            })}
          </List>
        </Box>
      </Drawer>
    </>
  );
};
